function Modal(modalMainWrapper, backdrop, show, onClose) {
  const modal = document.querySelector(modalMainWrapper);
  const modalBackdrop = document.querySelector(backdrop);
  const showModals = document.querySelectorAll(show);

  if (!modal || !modalBackdrop) return;

  const closeModal = () => {
    modal.classList.remove("show");
    modalBackdrop.classList.remove("show");
    if (typeof onClose === "function") onClose();
  };

  const openModal = () => {
    modal.classList.add("show");
    modalBackdrop.classList.add("show");
  };

  showModals.forEach((showModal) => {
    showModal.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      openModal();
    });
  });

  modalBackdrop.addEventListener("click", closeModal);

  modal.addEventListener("click", (e) => {
    if (e.target.closest(".modal__cancel")) {
      e.preventDefault();
      closeModal();
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.classList.contains("show")) {
      closeModal();
    }
  });

  document.addEventListener("click", (e) => {
    if (e.target.closest(modalMainWrapper)) return;
    if (e.target.closest(".modal__cancel")) return;

    let clickedOnShowButton = false;
    showModals.forEach((btn) => {
      if (btn.contains(e.target)) clickedOnShowButton = true;
    });

    if (!clickedOnShowButton && modal.classList.contains("show")) {
      closeModal();
    }
  });

  return { openModal, closeModal };
}

export default Modal;
